export const bottomButton = {
  position: "fixed",
  marginLeft: "17%",
  marginTop: "1vh",
  width: "66%",
  height: "6vh",
  fontSize: "120%",
};

export const bottomButtonScroll = {
  position: "fixed",
  marginLeft: "17%",
  marginTop: "1vh",
  width: "66%",
  height: "6vh",
  fontSize: "120%",
  bottom: "20px",
};

export const rowLeftBottomButtonScroll = {
  position: "fixed",
  marginLeft: "10%",
  marginTop: "1vh",
  width: "35%",
  height: "6vh",
  fontSize: "120%",
  bottom: "20px",
};

export const rowLeftBottomButton = {
  position: "fixed",
  marginLeft: "10%",
  marginTop: "1vh",
  width: "35%",
  height: "6vh",
  fontSize: "120%",
};

export const rowRightBottomButton = {
  position: "fixed",
  marginLeft: "55%",
  marginTop: "1vh",
  width: "35%",
  height: "6vh",
  fontSize: "120%",
};

export const rowRightBottomButtonScroll = {
  position: "fixed",
  marginLeft: "55%",
  marginTop: "1vh",
  width: "35%",
  height: "6vh",
  fontSize: "120%",
  bottom: "20px",
};

export const normalButton = {
  fontSize: "90%",
  maxHeight: "4.5vh",
};
